import { useEffect } from "react";

export const ForeverYoursMyQueen = ({ onClose }) => {
    useEffect(() => {
        // Function to handle keydown event
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                onClose(); // Call the onClose function when Esc is pressed
            }
        };

        // Add event listener when the component mounts
        window.addEventListener("keydown", handleKeyDown);

        // Clean up event listener when the component unmounts
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [onClose]);

    return (
        <>
            <div className="modal" style={{ display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "rgba(0, 0, 0, 0.5)", position: "fixed", top: 0, left: 0, width: "100%", height: "100%", overflowY: "auto", zIndex: 1050, }}>
                <div className="modal-content" style={{ padding: "20px", background: "#fff", borderRadius: "8px", maxWidth: "500px", width: "95%", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)", maxHeight: "95vh", overflowY: "auto", }}>
                    <div className="img-fluid mb-4">
                        <picture><img src="/media/poemseng/need-you-the-most.jpg" alt=" Forever Yours, My Queen | Lone Wolf writes " style={{ width: "100%", height: "18rem", objectFit: "cover", borderRadius: "6px", backgroundColor: "gray", }} /></picture>
                    </div>

                    <h2 style={{ textAlign: "center", color: "red" }}>Forever Yours, My Queen</h2>
                    <hr />

                    <p style={{ textAlign: "center" }}>
                        If they talk about me,<br />
                        They might say I'm the worst;<br />
                        But I’d change in a heartbeat,<br />
                        Because for you, I thirst.<br />
                        <br />
                        Stop dreaming of being a princess—<br />
                        You’re destined to be a queen.<br />
                        Let me stand as your king,<br />
                        In a life so grand, unseen.<br />
                        <br />
                        Ignoring my love<br />
                        Just wouldn’t be fair.<br />
                        I’ll always be waiting,<br />
                        To show how much I care.<br />
                        <br />
                        Through every storm,<br />
                        And no matter the weather,<br />
                        My love will stand strong,<br />
                        Always, forever.<br />
                        <br />
                        Hand in hand,<br />
                        Walking as one;<br />
                        Dreaming of moments<br />
                        That never are done.<br />
                        <br />
                        Come closer, my love,<br />
                        And leave the past behind.<br />
                        I’ll show you the meaning<br />
                        Of a love so divine.<br />
                        <br />
                        When life feels heavy,<br />
                        And you need a break,<br />
                        I’ll be your laughter,<br />
                        The smile you make.<br />
                        <br />
                        You ask why I love you—<br />
                        What’s driving me wild?<br />
                        Babe, just look in the mirror:<br />
                        You're heaven’s own style!<br />
                        <br />
                    </p>

                    <div className="modal-footer" style={{ textAlign: "right" }}>
                        <button type="button" onClick={onClose} className="btn btn-secondary" style={{ backgroundColor: "red", border: 0, padding: "10px 20px", color: "#fff", borderRadius: "5px", }}>
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};
